export default __webpack_public_path__ + "static/media/Orange Circle.643e19f0.svg";